import { heroStats, heroTags } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="top" className="relative w-full h-[560px] md:h-[680px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Moody%20abstract%20stage%20backdrop%20with%20deep%20crimson%20and%20warm%20amber%20spotlight%20beams%2C%20soft%20smoke%2C%20dark%20cinematic%20atmosphere%2C%20dramatic%20editorial%20lighting%20with%20rich%20contrast%20and%20generous%20negative%20space&width=1800&height=1000&seq=heitao-hero-a1&orientation=landscape"
        alt="黑料大全 热门榜 精华推荐 首页主视觉"
        title="黑料大全 热门榜与精华推荐"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/45 to-foreground-950/80" />

      <div className="relative z-10 w-full h-full px-4 md:px-8 flex flex-col justify-center">
        <div className="max-w-4xl">
          <p className="animate-fade-up inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/12 border border-background-50/25 text-background-100 text-xs md:text-sm font-label">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-400 animate-soft-pulse" />
            热门榜 · 精华推荐 · 每日滚动更新
          </p>

          <h1 className="animate-fade-up delay-1 mt-5 font-heading font-black text-background-50 text-4xl md:text-6xl leading-[1.15] tracking-tight">
            黑料大全
          </h1>

          <p className="animate-fade-up delay-2 mt-4 font-heading text-background-100 text-xl md:text-3xl leading-snug font-semibold">
            热门榜与精华推荐，一次看全必看清单、高能盘点与爆款合集
          </p>

          <p className="animate-fade-up delay-3 mt-4 max-w-2xl text-background-200/90 text-sm md:text-base leading-relaxed">
            精华榜单把热门榜、必看清单与高能盘点聚合在一起，爆款合集按热度排序。不知道先看哪个？从 TOP榜入口直接挑最炸的料，高效浏览不踩空。
          </p>

          <div className="animate-fade-up delay-4 mt-7 flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
            <a
              href="#top-chart"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 text-sm md:text-base font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-trophy-line" />
              进入 TOP榜
            </a>
            <a
              href="#collections"
              className="flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm md:text-base font-medium hover:bg-background-50/10 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-stack-line" />
              逛爆款合集
            </a>
          </div>

          <div className="mt-7 flex flex-wrap gap-2">
            {heroTags.map((tag) => (
              <span
                key={tag}
                className="px-3 py-1.5 rounded-full border border-background-50/25 bg-background-50/10 text-background-100 text-xs md:text-sm font-label"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className="absolute bottom-0 left-0 right-0 px-4 md:px-8 pb-6 md:pb-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 border-t border-background-50/20 pt-5">
            {heroStats.map((stat) => (
              <div key={stat.id} className="flex flex-col">
                <span className="font-heading font-bold text-background-50 text-xl md:text-2xl">
                  {stat.value}
                </span>
                <span className="mt-1 text-background-300 text-xs md:text-sm font-label">{stat.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}